"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.YellowBrimLogo = (_a) => {
    var { withText, height = 160, width = 160 } = _a, props = tslib_1.__rest(_a, ["withText", "height", "width"]);
    const svgComp = (react_1.default.createElement("svg", Object.assign({ width: width, height: height, viewBox: "0 0 160 150" }, props),
        react_1.default.createElement("title", null, "Yellow Brim"),
        react_1.default.createElement("path", { d: "M147.66 0H12.34C5.54 0 0 5.549 0 12.364v90.449c0 6.815 5.535 12.364 12.34 12.364h80.435L142.55 150l-.005-34.823h5.11c6.805 0 12.345-5.544 12.345-12.364V12.364C160 5.549 154.465 0 147.66 0zm-89.5 91.5h-5V70.198h5V91.5zm20.945 0h-5V75.41h5V91.5zM78.63 67.78L59.9 49.02 34.3 74.66l-3.535-3.541L59.9 41.939 78.63 60.7l38.095-38.154 3.535 3.54-41.63 41.694zM100.045 91.5h-5V64.86h5V91.5zm20.95 0h-5V43.902h5V91.5z", fill: "#273237", fillRule: "nonzero" })));
    if (withText) {
        return (react_1.default.createElement("div", null,
            svgComp,
            react_1.default.createElement("strong", { style: { color: '#273237' }, className: "ml-2" },
                react_1.default.createElement("span", { style: {
                        boxShadow: 'inset 0 -1px 0 0 #fff, inset 0 -3px 0 0 #ffeb3b',
                        textShadow: '1px 1px 0 #fff, -1px 1px 0 #fff, 2px 0 0 #fff, -2px 0 0 #fff',
                    } }, "yellow"),
                ' ',
                react_1.default.createElement("span", null, "brim"))));
    }
    return svgComp;
};
//# sourceMappingURL=YellowBrimLogo.js.map